import * as React from 'react';
import { useState, useEffect, useContext } from 'react';
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router";

import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import FormControl from '@mui/material/FormControl';
import { FormHelperText } from '@mui/material';

import { SelectTypeInput } from './SelectTypeInput';
import { TextTypeInput } from './TextTypeInput';
import { DateMonthPicker } from './DateMonthPicker';
import { SelectTypeWithMarker } from './SelectInputWithMarker';
import { UploadDoctorProfilePhoto } from './UploadDoctorProfilePhoto'
import { GenderSelector } from './GenderSelector';
import { EducationDialog } from './EducationDialog';
import { GovermentIdDialog } from './GovermentIdDialog';
import { MCIdDialog } from './MCIdDialog';
import { AwardsDialog } from './AwardsDialog';
import { McIDTableView } from './McIDTableView';
import { GovermentIdTableView } from './GovermentIdTableView';
import { AwardsTableView } from './AwardsTableView';
import { EducationTableView } from './EducationTableView';
import { titleOptions, LanguageArray, DaysArray } from './constant';
import { getProviderList, getProviderNameMapping, getProviderIdMapping, getUserDetails, getSpecialityList } from '../Helper/utils'
import { createOrUpdateDoctorDetails, getDoctorDetails } from '../Helper/API';
import { getProviderArray } from '../Helper/utils';
import { ToastEmitter } from '../ToastEmitter';
import { DisabledInputField } from './DisabledInputField';
import { specialties, routerLink, doctorListURL } from '../constant';
import { MultipleSelectTypeInput } from './MultipleSelectTypeInputV3'
import { logEventToAnalyticsPlatform, fetchUserDetailsAndSetUserForAnalytics } from "../../../helper/events"
import { EVENTS } from "../events_Constant"
import { TableStyle } from "../StyledComponent"
import { BackdropLoader } from '../BackdropLoader';
import UserFeaturesContext from '../../../hook/UserDetails/UserFeaturesContext';

export const DoctorProfileForm = ({ setDoctorProfileDetails, doctorProfileDetails, entityRelationProperty, setQCEnableOnSlots }) => {

    const {
        control,
        handleSubmit,
        formState: { errors, isDirty, isValid },
        reset,
        trigger,
        setError,
        getValues,
        setValue,
        watch,
        register,
        clearErrors
    } = useForm({
        mode: 'onBlur',
        defaultValues: {
            mciIds: [],
            doctorQualification: [],
            governmentIds: [],
            doctorAwards: [],
        }

    });

    const [mcId, setMCId] = useState([]);
    const [govermentId, setGovermentId] = useState([]);
    const [awards, setAwards] = useState([]);
    const [education, setEducation] = useState([]);
    const [gender, setGender] = useState();
    const [mbFeeValue, setMbFeeValue] = useState();
    const [providerFeeValue, setProviderFeeValue] = useState();
    const history = useHistory();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const doctorId = queryParams.get('drId');
    const [columnCheck, setColumnCheck] = useState(false);
    const [draftDisable, setDraftDisable] = useState(false);
    const [isProfileStatusDraft, setIsProfileStatusDraft] = useState(true);
    const [saveAsDraftEvent, setSaveAsDraftEvent] = useState(false)
    const [isDraftButtonVisible, setIsDraftButtonVisible] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [specialityArray,setSpecialityArray] = useState([]);

    const priceDetails = watch('priceDetails');
    const doctorPrefixWatch = watch('doctorprefix');
    const doctorFirstNameWatch = watch('doctorFirstName');
    const doctorGenderWatch = watch('gender');
    const doctorProviderWatch = watch('providerName');
    const doctorSpecializationWatch = watch('doctorSpecialization');
    const doctorLanguagesWatch = watch('doctorLanguages');
    const { OFCSpeciality } = useContext(UserFeaturesContext);

    const user_details = getUserDetails();
    const  isParentProvider = user_details?.parentProvider?.isParent;

    useEffect(() => {
        const disable = checkColumnsExisting();
        setDraftDisable(disable);
    }, [doctorPrefixWatch, doctorFirstNameWatch, doctorGenderWatch, doctorProviderWatch, doctorSpecializationWatch]);

    const transformDoctorData = (inputData, status) => {
        const providerId = getValues('providerId')
        return {
            doctors: inputData.doctors.map((doctor) => ({
                doctorprefix: doctor.doctorprefix,
                doctorFirstName: doctor.doctorFirstName.trim(),
                doctorLastName: doctor.doctorLastName.trim(),
                doctorDescription: doctor.doctorDescription,
                gender: doctor.gender,
                doctorIsActive: false,
                doctorId: parseInt(doctorId) || null,
                doctorQCStatus: status || 'Draft', 
                doctorPracticeStartDate: doctor?.doctorPracticeStartDate,
                doctorQualification: doctor.doctorQualification,
                doctorSpecialization: doctor.doctorSpecialization,
                providerName: doctor.providerName.trim(),
                providerId: doctor.providerId,
                priceDetails: {
                    customerFee: parseInt(doctor.priceDetails),
                    providerFee: parseInt(doctor.providerFee),
                    mbFee: typeof doctor.mbFee === 'string' ? parseFloat(doctor.mbFee) : doctor.mbFee,
                },
                freeFollowup: doctor?.freeFollowup,
                doctorLanguages: doctor.doctorLanguages || [],
                doctorAwards: doctor.doctorAwards || [],
                doctorImageUrl: doctor?.doctorImageUrl || '',
                mciIds: doctor.mciIds.map((mc) => ({
                    id: mc.id || null,
                    idType: 'license',
                    idName: mc.idName,
                    idNumber: mc.idNumber,
                    uploadedImages: mc.uploadedImages || [],
                    isActive: mc.isActive,
                })),
                governmentIds: doctor.govermentIds?.map((id) => ({
                    id: id.id || null,
                    idType: 'identity',
                    idName: id.idName,
                    idNumber: id.idNumber,
                    other: id.other,
                    uploadedImages: id.uploadedImages,
                    isActive: id.isActive,
                })),
                doctorAwards: doctor?.doctorAwards?.map((award) => ({
                    id: award.id || null,
                    name: award.name,
                    uploadedImages: award.uploadedImages || [],
                    isActive: award.isActive,
                })),
                doctorSource: "ProviderCentral",
            })),
            providerIds: [
                providerId
            ]
        };
    };

    useEffect(() => {
        const triggerEvents = async () => {
            await fetchUserDetailsAndSetUserForAnalytics();
            logEventToAnalyticsPlatform({
                name: EVENTS.PC_SCREEN_LANDING.name,
                payload: {
                    tab_name: EVENTS.TAB_NAME_ADD_EDIT_DOCTOR,
                    service_type: EVENTS.SERVICE_TYPE_OFFLINE_CONSULTS,
                    screenName: EVENTS.SERVICE_NAME_OFFLINE_CONSULTS,
                },
                schema: EVENTS.PC_SCREEN_LANDING.schema,
            })
        }
        triggerEvents();
        if(!isParentProvider) {
            setValue('providerName', user_details?.entityName)
        }
    }, [])

    useEffect(() => {
        const providerIdMapping = getProviderIdMapping();
        if (doctorProfileDetails && doctorProfileDetails.doctors && doctorProfileDetails.doctors.length > 0) {
            const doctor = doctorProfileDetails.doctors[0];
            setIsDraftButtonVisible(doctor?.doctorQCStatus?.toLowerCase() === 'draft')
            reset({
                doctorprefix: doctor?.doctorId ? doctor.doctorprefix : "Dr",
                doctorFirstName: doctor?.doctorFirstName || '',
                doctorLastName: doctor?.doctorLastName || '',
                doctorDescription: doctor?.doctorDescription,
                gender: (doctor?.gender ? (doctor.gender).toLowerCase() : ''),
                mciIds: doctor?.mciIds || [],
                doctorQualification: doctor?.doctorQualification || [],
                doctorSpecialization: doctor?.doctorSpecialization || '',
                providerName: providerIdMapping[doctor?.providerId] || '',
                priceDetails: doctor?.priceDetails?.customerFee || '',
                mbFee:doctor?.priceDetails?.mbFee || '',
                providerFee:doctor?.priceDetails?.providerFee || '',
                freeFollowup: doctor?.freeFollowup ? doctor.freeFollowup : '0',
                doctorLanguages: doctor?.doctorLanguages.length > 0 ? doctor?.doctorLanguages : [],
                doctorAwards: doctor?.doctorAwards || [],
                doctorImageUrl: doctor?.doctorImageUrl || '',
                governmentIds: doctor?.governmentIds || [],
                doctorPracticeStartDate: doctor?.doctorPracticeStartDate || '',

            })

            if (doctor?.doctorQCStatus) {
                if (doctor.doctorQCStatus.toLowerCase() != 'draft')
                    setIsProfileStatusDraft(false);
            }
            const disable = checkColumnsExisting();
            setColumnCheck(!disable);
            setMCId(doctor?.mciIds || []);
            setAwards(doctor?.doctorAwards || []);
            setEducation(doctor?.doctorQualification || []);
            setGovermentId(doctor?.governmentIds || []);
            setGender((doctor?.gender && doctor?.gender.toLowerCase()) || '');
            setMbFeeValue(parseFloat((doctor?.priceDetails?.mbFee).toFixed(2)));
            setProviderFeeValue(parseFloat((doctor?.priceDetails?.providerFee).toFixed(2)));
            const qcRemarks = doctor.doctorQCRemarks;
            Object.keys(qcRemarks).forEach((key) => {
                if (qcRemarks[key].status === 'Failed') {
                    setError(key, {
                        type: 'manual',
                        message: qcRemarks[key].remarks || 'Error',
                    });
                }
            });
        }
    }, [doctorProfileDetails]);

    useEffect(() => {
        if (getValues('priceDetails')) {
            const fee = getValues('priceDetails');
            const mbCharge = parseInt(entityRelationProperty?.value || 20);
            setValue('mbFee', parseFloat((fee * mbCharge / 100).toFixed(2)));
            setValue('providerFee', parseFloat((fee * (1 - mbCharge / 100)).toFixed(2)));
            setMbFeeValue(parseFloat((fee * mbCharge / 100).toFixed(2)));
            setProviderFeeValue(parseFloat((fee * (1 - mbCharge / 100)).toFixed(2)));
        }
        else {
            setValue('mbFee', '');
            setValue('providerFee', '');
            setMbFeeValue(0);
            setProviderFeeValue(0);
        }
    }, [priceDetails]);


    useEffect(() => {
        if (saveAsDraftEvent && doctorProfileDetails) {
            const updatedProfileDetails = doctorProfileDetails?.doctors ? doctorProfileDetails?.doctors[0] : null;
            logEventToAnalyticsPlatform({
                name: EVENTS.PC_LS_ACTION.name,
                payload: {
                    tab_name: EVENTS.TAB_NAME.ADD_DOCTOR,
                    filterValue: '',
                    reference_id: "" + updatedProfileDetails?.doctorId,
                    reference_provider_id: "" + updatedProfileDetails?.providerId,
                    reference_provider_name: updatedProfileDetails?.providerName,
                    service_name: EVENTS.SERVICE_NAME_OFFLINE_CONSULTS,
                    action: EVENTS.ACTION.SAVE_AS_DRAFT,
                },
                schema: EVENTS.PC_LS_ACTION.schema,
            })
            history.push(doctorListURL)
        }
    }, [saveAsDraftEvent, doctorProfileDetails])
    const filterInvalidandUpdateForm = (array, name) => {
        if (array && array.length > 0) {
            setValue(name, array, { shouldValidate: true, shouldDirty: true });
            setMCId(array);
            trigger(name);
        }
    }

    const submitMcId = (data) => {
        if (!data && data.length == 0) return;
        filterInvalidandUpdateForm(data, 'mciIds');
    }

    const submitEducation = (data) => {
        if (!data && data.length == 0) return
        setValue('doctorQualification', data, { shouldValidate: true, shouldDirty: true })
        setEducation(data);
    }

    const submitGovermentId = (data) => {
        if (!data && data.length == 0) return
        setValue('govermentIds', data, { shouldValidate: true, shouldDirty: true })
        setGovermentId(data);
    }

    const submitAwards = (data) => {
        if (!data && data.length == 0) return
        setValue('doctorAwards', data, { shouldValidate: true, shouldDirty: true })
        setAwards(data);
    }

    const checkColumnsExisting = () => {
        if (getValues('doctorFirstName').trim() == '' || getValues('providerName') == ''
            || getValues('doctorSpecialization') == '') {
            return true;
        }
        else {
            return false;
        }
    }

    const handleDoctorSubmit = async (status) => {
        const providerNameMapping = getProviderNameMapping();
        const providerName = getValues('providerName')
        const providerId = parseInt(providerNameMapping[providerName]);
        setValue('providerId', providerId)
        const inputData = {
            doctors: [getValues()]
        }
        const transformedData = transformDoctorData(inputData, status);
        const resp = await createAndUpdateDoctor(transformedData);
        return resp;
    }

    const saveAsDraft = async () => {
        const isValidForm = await trigger(['doctorFirstName', 'providerName', 'gender']);
        if (isValidForm) {
            setIsLoading(true);
            const resp = await handleDoctorSubmit('Draft', false);

            if (resp) {
                setSaveAsDraftEvent(true)
            }
            setIsLoading(false);
        }

        else {
            ToastEmitter('Mandatory Feilds Missing/ Incorect Details Filled', 'error')
        }

    };

    const submitAndProceed = async () => {


        if (!isDirty) return;
        setIsLoading(true);
        if (!isProfileStatusDraft) {
            const resp = await handleDoctorSubmit('InProgress', false);
            if (resp) {
                const updatedProfileDetails = resp?.doctors ? resp?.doctors[0] : null;
                logEventToAnalyticsPlatform({
                    name: EVENTS.PC_LS_ACTION.name,
                    payload: {
                        tab_name: EVENTS.TAB_NAME.ADD_DOCTOR,
                        filterValue: '',
                        reference_id: "" + updatedProfileDetails?.doctorId,
                        reference_provider_id: "" + updatedProfileDetails?.providerId,
                        reference_provider_name: updatedProfileDetails?.providerName,
                        service_name: EVENTS.SERVICE_NAME_OFFLINE_CONSULTS,
                        action: EVENTS.ACTION.SUBMIT_TO_QC,
                    },
                    schema: EVENTS.PC_LS_ACTION.schema,
                })
                history.push(doctorListURL)
            }
            
        }
        else {
            const resp = await handleDoctorSubmit('Draft', true);
            if (resp) {
                const updatedProfileDetails = resp?.doctors ? resp?.doctors[0] : null;
                logEventToAnalyticsPlatform({
                    name: EVENTS.PC_LS_ACTION.name,
                    payload: {
                        tab_name: EVENTS.TAB_NAME.ADD_DOCTOR,
                        filterValue: '',
                        reference_id: "" + updatedProfileDetails?.doctorId,
                        reference_provider_id: "" + updatedProfileDetails?.providerId,
                        reference_provider_name: updatedProfileDetails?.providerName,
                        service_name: EVENTS.SERVICE_NAME_OFFLINE_CONSULTS,
                        action: EVENTS.ACTION.SAVE_AND_PROCEED,
                    },
                    schema: EVENTS.PC_LS_ACTION.schema,
                })
                setQCEnableOnSlots(true);
                history.push(routerLink.schedule);
            }

        }
        setIsLoading(false);
    }

    const createAndUpdateDoctor = async (transformedData) => {
        try {
            const createDoctorResp = await createOrUpdateDoctorDetails(transformedData);
            if (createDoctorResp.success) {
                const resp = await getDoctorDetails({ providerIds: getProviderArray(), doctorId: createDoctorResp.data.successEntries[0].doctorId });
                setDoctorProfileDetails(resp.data);
                ToastEmitter('Doctor Profile Saved Successfully', 'success');
                return resp.data
            }
            else {
                ToastEmitter('Something went wrong Please Try Again', 'error');
                return false;
            }
        }
        catch (err) {
            ToastEmitter('Something went wrong Please Try Again', 'error');
            return false;
        }
    }

    useEffect(() => {
        const specialityArray = getSpecialityList(OFCSpeciality);
        setSpecialityArray(specialityArray)
      }, [OFCSpeciality])

    return (

        <>

            {isLoading && <BackdropLoader isLoading={isLoading} />}
            <List sx={TableStyle} className='w-[80vw] '>
                <div className='flex flex-col gap-6 '>
                    <div className=""></div>
                    {isParentProvider && <>
                        <div className="flex gap-x-32 p-4  pt-6  items-center" style={{ gap: '5rem' }}>
                            <div className="flex text-base font-semibold text-[#47566A]" style={{ width: '20vw', justifyContent: 'flex-end', }}>
                                Provider Branch
                                <p className=' text-mb-red' >*</p>
                            </div>
                            <div className="flex flex-row" style={{ gap: '1.5rem' }}>
                                <FormControl error={!!errors.providerName}>
                                    <SelectTypeInput
                                        name={'providerName'}
                                        placeholder={'Select Branch'}
                                        control={control}
                                        width={'31.6rem'}
                                        height={'2.75rem'}
                                        defaultValue=''
                                        rules={{
                                            required: "Mandatory Information",
                                        }}
                                        options={getProviderList().map((specialty) => ({ value: specialty, title: specialty }))} //thjis one we have to put effort
                                        errors={errors}
                                        columnCheck={columnCheck}
                                    />

                                </FormControl>
                            </div>
                        </div>
                        <Divider variant='middle' component="li" />
                    </>}

                    <div className="flex gap-x-32 p-4" style={{ gap: '5rem' }}>
                        <div className="flex text-base font-semibold text-[#47566A]" style={{ width: '20vw', justifyContent: 'flex-end', }}>
                            Name
                            <p className=' text-mb-red' >*</p>
                        </div>
                        <div className="flex flex-row " style={{ gap: '1.5rem' }}>
                            <FormControl error={!!errors.doctorprefix} >
                                <SelectTypeInput
                                    name={'doctorprefix'}
                                    label={'Title'}
                                    control={control}
                                    defaultValue="Dr"
                                    width={'5.5rem'}
                                    height={'2.75rem'}
                                    value='Dr'
                                    options={titleOptions}
                                    errors={errors}
                                />
                            </FormControl>

                            <FormControl error={!!errors.doctorFirstName}>
                                <TextTypeInput
                                    name={'doctorFirstName'}
                                    label={'First Name'}
                                    placeholder="First Name"
                                    control={control}
                                    defaultValue=""
                                    width={'15.25rem'}
                                    height={'2.75rem'}
                                    rules={{
                                        required: "Mandatory Information",
                                        validate: {
                                            isValidName: (val) => {
                                                const trimmedVal = val.trim();
                                                const validNameRegex = /^[A-Za-z\s.]+$/;

                                                if (!validNameRegex.test(trimmedVal)) {
                                                    return "Only A-Z, a-z, '.' and spaces are allowed."
                                                }

                                                if (trimmedVal.length === 0) {
                                                    return 'Name cannot be empty.';
                                                }
                                                return true;
                                            }

                                        }
                                    }}
                                    errors={errors}
                                    columnCheck={columnCheck}
                                />
                            </FormControl>

                            <FormControl error={!!errors.doctorLastName}>
                                <TextTypeInput
                                    name={'doctorLastName'}
                                    label={'Last Name'}
                                    placeholder="Last Name"
                                    control={control}
                                    defaultValue=""
                                    width={'15.25rem'}
                                    height={'2.75rem'}
                                    rules={{
                                        validate: {
                                            isValidName: (val) => {
                                                const trimmedVal = val.trim();
                                                const validNameRegex = /^[A-Za-z\s.]+$/;
                                                if (trimmedVal.length>0 && !validNameRegex.test(trimmedVal)) {
                                                    return "Only A-Z, a-z, '.' and spaces are allowed."
                                                }
                                                return true;
                                            }
                                        }
                                    }}
                                    errors={errors}
                                />
                            </FormControl>
                        </div>
                    </div>

                    <Divider variant='middle' component="li" />


                    <div className="flex gap-x-32 p-4" style={{ gap: '5rem' }}>
                        <div className="flex text-base font-semibold text-[#47566A]" style={{ width: '20vw', justifyContent: 'flex-end', }}>
                            Speciality/Department
                            <p className=' text-mb-red' >*</p>
                        </div>
                        <div className="flex flex-row" style={{ gap: '1.5rem' }}>
                            <FormControl error={!!errors.doctorSpecialization} sx={{ m: 1, minWidth: 120 }}>
                                <SelectTypeInput
                                    name={'doctorSpecialization'}
                                    placeholder={getValues('doctorSpecialization') || 'Select Speciality / Department'}
                                    control={control}
                                    width={'31.6rem'}
                                    height={'2.75rem'}
                                    defaultValue=''
                                    rules={{ required: "Mandatory Information" }}
                                    errors={errors}
                                    options={specialityArray.map((specialty) => ({ value: specialty, title: specialty }))}
                                />
                            </FormControl>
                        </div>
                    </div>

                    <Divider variant='middle' component="li" />

                    <div className="flex gap-x-32 p-4" style={{ gap: '5rem' }}>
                        <div className="flex text-base font-semibold text-[#47566A]" style={{ width: '20vw', justifyContent: 'flex-end', }}>
                            Description
                        </div>
                        <div className="flex flex-row " style={{ gap: '1.5rem' }}>
                            <FormControl error={!!errors.doctorDescription}>
                                <TextTypeInput
                                    name={'doctorDescription'}
                                    placeholder="Add Description"
                                    control={control}
                                    defaultValue=""
                                    width={'38.80rem'}
                                    height={'8rem'}
                                    rules={{
                                        validate: (val) => {
                                            return val.length < 300 || 'Limit is 150 words only'
                                        }
                                    }}
                                    multiLine={true}
                                    errors={errors}
                                />
                            </FormControl>
                        </div>
                    </div>

                    <Divider variant='middle' component="li" />

                    <div className="flex flex-row p-4" style={{ gap: '5rem' }}>
                        <div className="flex flex-col text-base font-semibold text-[#47566A] " style={{ width: '20vw', justifyContent: 'flex-start', alignItems: 'flex-end' }}>
                            <div className="flex flex-row ">
                                Doctor Photo
                                <p className="text-mb-red">*</p>
                            </div>
                            <div className="self-end text-sm font-normal text-[#70829B] " style={{ width: '50%', textAlign: 'right' }} >
                                This will be displayed on Doctor profile.
                            </div>
                        </div>
                        <div className="flex flex-row" style={{ gap: '1.5rem' }}>
                            <FormControl error={!!errors.doctorImageUrl}>
                                <div className="flex flex-col gap-1">
                                    <input type="hidden" {...register('doctorImageUrl', { required: "Mandatory Information" })} />
                                    <div className="flex  border border-solid rounded-xl border-[#DBE0E6]   justify-center" style={{ width: 'fit-content' }}>
                                        <UploadDoctorProfilePhoto getValues={getValues} setValue={setValue} name={'doctorImageUrl'} />
                                    </div>
                                    {errors.doctorImageUrl && <FormHelperText>{errors.doctorImageUrl.message}</FormHelperText>}
                                </div>
                            </FormControl>

                            <img src="https://views.medibuddy.in/providerUi/assets/DoctorProfileInfoUpdated.svg" alt="" className='flex justify-center ' style={{ width: '18.6rem', height: '8.75rem' }} />
                        </div>
                    </div>

                    <Divider variant='middle' component="li" />

                    <div className="flex flex-row p-4" style={{ gap: '5rem' }}>
                        <div className="flex flex-col text-base font-semibold text-[#47566A] " style={{ width: '20vw', justifyContent: 'flex-start', alignItems: 'flex-end' }}>
                            <div className="flex flex-row ">
                                Gender
                                <p className="text-mb-red">*</p>
                            </div>
                        </div>
                        <div className="flex flex-row" style={{ gap: '1.5rem' }}>
                            <input type="hidden" {...register('gender', { required: "Mandatory Information" })} />
                            <GenderSelector
                                name={'gender'}
                                setValue={setValue}
                                getValues={getValues}
                                gender={gender}
                                setGender={setGender}
                                errors={errors}
                            />
                        </div>
                    </div>

                    <Divider variant='middle' component="li" />

                    <div className="flex flex-row p-4" style={{ gap: '5rem' }}>
                        <div className="flex flex-col text-base font-semibold text-[#47566A] " style={{ width: '20vw', justifyContent: 'flex-start', alignItems: 'flex-end' }}>
                            <div className="flex flex-row ">
                                MCI ID
                            </div>
                        </div>
                        <FormControl error={!!errors.mciIds}>
                            <div className="flex flex-col justify-fit fit-content" style={{ gap: '1.5rem' }}>
                                <input type="hidden" {...register('mciIds', {
                                    // validate: (value) => {
                                    //     if (!Array.isArray(mcId)) {
                                    //       return "Mandatory Information";
                                    //     }    
                                    //     const activeItems = mcId.filter((item) => item.isActive === true);
                                    //     return activeItems.length > 0 || "Mandatory Information";
                                    //   }
                                })} />
                                <div className="">
                                    <MCIdDialog
                                        mcId={mcId}
                                        setMCId={submitMcId}
                                        setValue={setValue}
                                        name={'mciIds'}
                                    />
                                </div>
                                {mcId?.length > 0 &&
                                    <McIDTableView
                                        documentList={mcId}
                                        setDocumentList={submitMcId}
                                    />
                                }
                            </div>
                            <div className="flex flex-col flex-start justify-start " style={{ paddingLeft: '-1.5rem' }}>
                                {errors.mciIds && <FormHelperText>{errors.mciIds.message}</FormHelperText>}

                            </div>
                        </FormControl>
                    </div>

                    <Divider variant='middle' component="li" />

                    <div className="flex flex-row p-4" style={{ gap: '5rem' }}>
                        <div className="flex flex-col text-base font-semibold text-[#47566A] " style={{ width: '20vw', justifyContent: 'flex-start', alignItems: 'flex-end' }}>
                            <div className="flex flex-row ">
                                Education
                                <p className="text-mb-red">*</p>
                            </div>
                        </div>
                        <FormControl error={!!errors.doctorQualification}>
                            <div className="flex flex-col justify-fit fit-content" style={{ gap: '1.5rem' }}>
                                <input type="hidden" {...register('doctorQualification', { required: "Mandatory Information" })} />
                                <div className="">
                                    <EducationDialog
                                        setEducation={submitEducation}
                                        education={education}
                                        setValue={setValue}
                                        name={'doctorQualification'}
                                    />
                                </div>
                                {education?.length > 0 &&
                                    <EducationTableView
                                        documentList={education}
                                        setDocumentList={submitEducation}
                                    />
                                }
                            </div>
                            <div className="flex flex-col flex-start justify-start " style={{ paddingLeft: '-1.5rem' }}>
                                {errors.doctorQualification && <FormHelperText>{errors.doctorQualification.message}</FormHelperText>}

                            </div>
                        </FormControl>
                    </div>
                    <Divider variant='middle' component="li" />

                    <div className="flex gap-x-32 p-4" style={{ gap: '5rem' }}>
                        <div className="flex text-base font-semibold text-[#47566A]" style={{ width: '20vw', justifyContent: 'flex-end', }}>
                            Practice Start Date
                            <p className=' text-mb-red' >*</p>
                        </div>
                        <div className="flex flex-row" style={{ gap: '1.5rem' }}>
                            <FormControl error={!!errors['doctorPracticeStartDate']}>
                                <DateMonthPicker
                                    name={'doctorPracticeStartDate'}
                                    control={control}
                                    defaultValue={new Date()}
                                    rules={{
                                        required: "Mandatory Information",
                                        validate: {
                                            isValidDate: (val) => {
                                                const date = new Date(val);
                                                if (isNaN(date)) {
                                                    return "Invalid Start date ";
                                                }
                                                if (val > new Date()) {
                                                    return "Invalid Practice Start Date"
                                                }
                                                return true;
                                            }
                                        }
                                    }}
                                    errors={errors}
                                />
                                <div className="flex flex-col flex-start justify-start " style={{ paddingLeft: '-1.5rem' }}>
                                    {errors.doctorPracticeStartDate && <FormHelperText>{errors.doctorPracticeStartDate.message}</FormHelperText>}
                                </div>
                            </FormControl>
                        </div>
                    </div>

                    <Divider variant='middle' component="li" />

                    <div className="flex gap-x-32 p-4" style={{ gap: '5rem' }}>
                        <div className="flex text-base font-semibold text-[#47566A]" style={{ width: '20vw', justifyContent: 'flex-end', }}>
                            Fees
                            <p className=' text-mb-red' >*</p>
                        </div>
                        <div className="flex flex-row" style={{ gap: '1.5rem' }}>
                            <FormControl error={!!errors.priceDetails}>
                                <TextTypeInput
                                    name={'priceDetails'}
                                    inputType={'number'}
                                    label={'Consultation Fee'}
                                    inputAdornment={true}
                                    placeholder="Enter Amount"
                                    control={control}
                                    defaultValue=""
                                    width={'10.5rem'}
                                    height={'2.75rem'}
                                    rules={{
                                        required: "Mandatory Information",
                                        pattern: {
                                            value: /^[0-9]*$/,
                                            message: 'Invalid Input',
                                        },
                                        validate: (val) => {
                                            return (val > 0 && val<10000) || 'Invalid Input'
                                        },
                                        valueAsNumber: true,
                                    }}
                                    errors={errors}
                                />

                            </FormControl>

                            {/* <input type="hidden" {...register('providerFee')} />
                        <DisabledInputField
                            label={'Provider Fee'}
                            placeholder="Provider Fee"
                            defaultValue=""
                            inputAdornment={true}
                            value={providerFeeValue}
                            width={'9.5rem'}
                            height={'2.75rem'}
                        />

                        <input type="hidden" {...register('mbFee')} />
                        <DisabledInputField
                            label={'MB Fee'}
                            placeholder="MB Fee"
                            defaultValue=""
                            inputAdornment={true}
                            value={mbFeeValue}
                            width={'9.5rem'}
                            height={'2.75rem'}
                        /> */}

                        </div>
                    </div>

                    <Divider variant='middle' component="li" />

                    <div className="flex gap-x-32 p-4" style={{ gap: '5rem' }}>
                        <div className="flex text-base font-semibold text-[#47566A]" style={{ width: '20vw', justifyContent: 'flex-end', }}>
                            Spoken Language/’s
                            <p className=' text-mb-red' >*</p>
                        </div>
                        <div className="flex flex-row" style={{ gap: '1.5rem' }}>
                            <FormControl error={!!errors.doctorLanguages} sx={{ m: 1, minWidth: 120 }}>
                                <MultipleSelectTypeInput
                                    name={'doctorLanguages'}
                                    placeholder={'Select 1 or more languages from the list'}
                                    control={control}
                                    width={'31.6rem'}
                                    height={'2.75rem'}
                                    defaultValue=''
                                    errors={errors}
                                    selectArray={LanguageArray}
                                    getValues={doctorLanguagesWatch}
                                    rules={{
                                        required: "Mandatory Information",
                                    }}
                                />
                            </FormControl>
                        </div>
                    </div>

                    <Divider variant='middle' component="li" />

                    <div className="flex gap-x-32 p-4" style={{ gap: '5rem' }}>
                        <div className="flex text-base font-semibold text-[#47566A]" style={{ width: '20vw', justifyContent: 'flex-end', }}>
                            Free Follow Up
                        </div>
                        <div className="flex flex-row" style={{ gap: '1.5rem' }}>
                            <FormControl error={!!errors.freeFollowup} sx={{ m: 1, minWidth: 120 }}>
                                <SelectTypeWithMarker
                                    name={'freeFollowup'}
                                    placeholder={'Select days'}
                                    endMarker={'days'}
                                    control={control}
                                    width={'15.1rem'}
                                    height={'2.75rem'}
                                    errors={errors}
                                    selectArray={DaysArray}
                                />
                            </FormControl>
                        </div>
                    </div>

                    <Divider variant='middle' component="li" />


                    <div className="flex flex-row p-4" style={{ gap: '5rem' }}>
                        <div className="flex flex-col text-base font-semibold text-[#47566A] " style={{ width: '20vw', justifyContent: 'flex-start', alignItems: 'flex-end' }}>
                            <div className="flex flex-row ">
                                Government ID
                            </div>
                        </div>
                        <div className="flex flex-col justify-fit fit-content" style={{ gap: '1.5rem' }}>
                            <FormControl error={!!errors.governmentIds}>
                                <div className="">
                                    <input type="hidden" {...register('governmentIds')} />
                                    <GovermentIdDialog
                                        setGovermentId={submitGovermentId}
                                        govermentId={govermentId} />
                                </div>
                                {govermentId?.length > 0 &&
                                    <GovermentIdTableView
                                        documentList={govermentId}
                                        setDocumentList={submitGovermentId}
                                    />
                                }
                                {errors.governmentIds && <FormHelperText >{errors.governmentIds.message} </FormHelperText>}
                            </FormControl>
                        </div>
                    </div>

                    <Divider variant='middle' component="li" />

                    <div className="flex flex-row p-4" style={{ gap: '5rem' }}>
                        <div className="flex flex-col text-base font-semibold text-[#47566A] " style={{ width: '20vw', justifyContent: 'flex-start', alignItems: 'flex-end' }}>
                            <div className="flex flex-row ">
                                Awards & Recognition
                            </div>
                        </div>
                        <div className="flex flex-col justify-fit fit-content" style={{ gap: '1.5rem' }}>
                            <FormControl error={!!errors.doctorAwards}>
                                <div className="">
                                    <input type="hidden" {...register('doctorAwards')} />
                                    <AwardsDialog
                                        setAwards={submitAwards}
                                        awards={awards}
                                    />
                                </div>
                                {awards?.length > 0 &&
                                    <AwardsTableView
                                        documentList={awards}
                                        setDocumentList={submitAwards}
                                    />
                                }
                                {errors.doctorAwards && <FormHelperText >{errors.doctorAwards.message} </FormHelperText>}
                            </FormControl>
                        </div>
                    </div>

                    <Divider variant='fullWidth' />
                    <div className="flex flex-row justify-end gap-2 px-4 py-6 text-sm font-semibold bg-[#F5F7F8] ">
                        <button className="flex flex-col justify-center border rounded-lg px-6 py-2 border-[#DBE0E6] font-semibold "
                            onClick={(e) => { e.preventDefault(); history.push('/offlineConsults/DoctorManagement') }}>
                            Close
                        </button>
                        {isDraftButtonVisible && <button
                            disabled={!isDirty || draftDisable}
                            className={`${!isDirty || draftDisable ? ' cursor-not-allowed text-[#DBE0E6]  border-[#DBE0E6] ' : ' border-blue-500 text-blue-700 '} " flex flex-col justify-center py-2 px-5 border  rounded-lg text-semibold "`}
                            onClick={saveAsDraft}
                        >
                            Save Draft
                        </button>
                        }
                        <button
                            className={`${isValid && isDirty ? ' border-blue-700 text-white bg-blue-600 ' : ' bg-[#F5F7F8] border-[#DBE0E6] '} "flex flex-col justify-center py-2 px-4 border rounded-lg "`}
                            style={{ color: isValid && isDirty ? 'white' : '#A4B0C0' }}
                            disabled={(isDirty) ? false : true}
                            onClick={handleSubmit(submitAndProceed)}>
                            {isProfileStatusDraft ? 'Save & Proceed ' : 'Submit to QC'}
                        </button>
                    </div>
                </div>
            </List >
        </>

    );
}


